import _ from "lodash";
import dayjs from "dayjs";

export const composeValidators =
  (...validators) =>
  (value, allValues) =>
    validators.reduce(
      (error, validator) => error || validator(value, allValues),
      undefined
    );

export const required = (value) => {
  if (Array.isArray(value)) {
    if (value.length > 0) {
      return undefined;
    }
    return "required";
  }
  return !value && isNaN(value)
    ? "required"
    : value != null && _.trim(value + "" || "")
    ? undefined
    : "required";
};

export const validateAplahbetsAndSpace = (value) => {
  const regex = /^[a-zA-Z\s]*$/;
  return value.match(regex) ? undefined : "invalidAlpha";
};

export const requiredDependent = (dependOn, dependentValue) => {
  return (value, allValues) => {
    if (
      allValues[dependOn] === true ||
      (dependentValue &&
        (allValues[dependOn] === dependentValue ||
          allValues[dependOn]?.value === dependentValue))
    ) {
      if (Array.isArray(value)) {
        if (value.length > 0) {
          return undefined;
        }
        return "required";
      }
      return !value && isNaN(value)
        ? "required"
        : _.trim(value + "" || "")
        ? undefined
        : "required";
    }
  };
};

export const numberGreater0 = (value) => {
  const updatedValue = parseFloat(value);
  if (isNaN(updatedValue) || updatedValue <= 0) {
    return "invalidNumber0";
  }

  return undefined;
};

export const numberPositive = (value) => {
  const updatedValue = parseFloat(value);
  if (isNaN(updatedValue) || updatedValue < 0) {
    return "invalidNumber+";
  }

  return undefined;
};

export const checkEmailFormat = (value = "") => {
  if (value) {
    const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,15})+$/;
    return value.match(regex) ? undefined : "invalidEmail";
  }
  return undefined;
};

export const maxLength = (length) => {
  return (value) => {
    return value?.length > length ? "maxlength" : undefined;
  };
};

export const minLength = (length) => {
  return (value) => {
    return ((value && value.length) || 0) < length ? "minlength" : undefined;
  };
};

export const checkConfirmPassword = (value, allValues) => {
  return allValues?.newPassword !== value
    ? "confirmPasswordMismatch"
    : undefined;
};

export const oldPasswordSame = (value, allValues) => {
  return allValues.oldPassword === value ? "oldPasswordSame" : undefined;
};

export const maxDate = (maxDate) => {
  return (value) => {
    return dayjs(value) > dayjs(maxDate) ? "maxDate" : undefined;
  };
};

export const minDate = (minDateKey) => {
  return (value, allValues) => {
    if (!value || !allValues[minDateKey]) {
      return undefined;
    }
    return dayjs(value) < dayjs(allValues[minDateKey]) ? "minDate" : undefined;
  };
};

export const combinedMaxValue = (otherFields, maxValue) => {
  return (value, allValues) => {
    let totalValue = parseInt(value) || 0;
    otherFields.forEach(
      (otherField) => (totalValue += parseInt(allValues[otherField]) || 0)
    );
    if (totalValue > maxValue) {
      return "maxCombinedValue";
    }

    return undefined;
  };
};

export const validateWithCallback = (callback) => {
  return (value) => {
    return callback(value);
  };
};

export const validateStrongPassword = (value) => {
  const strongPasswordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
  return value.match(strongPasswordRegex) ? undefined : "invalidStrongPassword";
};
